var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg044DepartureBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M489.822,164.652c-43.376-16.014-89.984-18.441-134.788-7.019l-58.221,14.843L131.857,77.903 c-3.39-1.943-7.401-2.49-11.19-1.525L51.38,94.043c-5.598,1.427-9.882,5.936-11.023,11.6c-1.14,5.663,1.066,11.479,5.677,14.96 l114.641,86.581l-47.206,12.035l-65.035-38.557c-6.868-4.071-15.721-2.063-20.16,4.575L2.536,223.73 c-3.903,5.837-3.244,13.598,1.586,18.694l77.814,82.101c2.875,3.033,6.836,4.692,10.91,4.692c1.236,0,2.483-0.153,3.712-0.466 l389.895-99.398c14.7-3.748,24.709-15.96,25.497-31.11C512.74,183.091,504.054,169.907,489.822,164.652z M479.026,200.222 L97.683,297.441L34.2,230.459l11.15-16.677l58.14,34.468c3.426,2.031,7.519,2.619,11.377,1.635l83.522-21.293 c5.599-1.427,9.882-5.936,11.023-11.6c1.14-5.663-1.066-11.478-5.677-14.96L89.093,115.451l33.098-8.437l164.956,94.572 c3.391,1.944,7.406,2.489,11.189,1.525l64.124-16.347c38.876-9.91,79.314-7.805,116.949,6.09c1.772,0.653,2.618,1.941,2.521,3.825 C481.833,198.562,480.855,199.755,479.026,200.222z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M258.918,406.026H15.031c-8.301,0-15.031,6.73-15.031,15.031c0,8.301,6.73,15.031,15.031,15.031h243.886 c8.301,0,15.031-6.73,15.031-15.031C273.948,412.756,267.219,406.026,258.918,406.026z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg044DepartureBlue);
export default __webpack_public_path__ + "static/media/044-departure-blue.3da87e04.svg";
export { ForwardRef as ReactComponent };